import React, { Component } from 'react';
import 'semantic-ui-css/semantic.min.css'
import { Header,Container } from 'semantic-ui-react'



class Policy extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
    }
  }



  render() {
    return (
      <div className=" app align-items-center">
        <div className="row" style={{ marginTop: 20, marginLeft: 20, }}>
          <div className="col-md-12 grid-margin stretch-card">
            <Container textAlign='justified'>
              <Header as='h2'>Privacy Policy</Header>
              <p style={{ fontSize: 16, marginBottom: 5 }} >
                C2NRG built the Hand hygiene audit app as a Free app. This SERVICE is provided by C2NRG at 
                no cost and is intended for use as is.
              </p>
              <p style={{ fontSize: 16, marginTop: 5, marginBottom: 5}} >This page is used to inform visitors regarding our policies with the collection, use, 
                and disclosure of Personal Information if anyone decided to use our Service.
              </p>
              <p style={{ fontSize: 16, marginTop: 5, marginBottom: 5}} >If you choose to use our Service, then you agree to the collection and use of information in
                relation to this policy. The Personal Information that we collect is used for providing and improving
                the Service. We will not use or share your information with anyone except as described
                in this Privacy Policy.
              </p>
              <p style={{ fontSize: 16, marginTop: 5, marginBottom: 5}} >
                The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is
                accessible at Hand hygiene audit unless otherwise defined in this Privacy Policy.
              </p>
              <p style={{ fontSize: 20, marginTop: 5, marginBottom: 5}} >
                <strong>Information Collection and Use</strong></p> 
                <p style={{ fontSize: 16, marginTop: 5, marginBottom: 5}}>For a better experience, while using our Service, we may require you to provide us with certain
                  personally identifiable information. The information that we request will be retained on your device and is not collected by us in any way. In addition, 
                  the user's position is collected to ensure the authorization of usage.
              </p >
              <p style={{ fontSize: 16, marginTop: 5, marginBottom: 5}}>The app does use third party services that may 
              collect information used to identify you.</p>
              <p style={{ fontSize: 16, marginTop: 5, marginBottom: 5}}>
                Link to privacy policy of third party service providers used by the app
              </p>

              <ul><li><a style={{ fontSize: 16, marginTop: 5, marginBottom: 5}} href="https://www.google.com/policies/privacy/" 
              target="_blank">Google Play Services</a></li></ul>
              {/* link 1 */}

              <p style={{ fontSize: 20, marginTop: 5, marginBottom: 5}}><strong>Log Data</strong></p> 
              <p style={{ fontSize: 16, marginTop: 5, marginBottom: 5}}> We want to inform you that whenever you use my Service, in a case of
                an error in the app we collect data and information (through third party products) on your phone
                called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address,
                device name, operating system version, the configuration of the app when utilizing my Service,
                the time and date of your use of the Service, and other statistics.
              </p>
              <p style={{ fontSize: 20, marginTop: 5, marginBottom: 5}}><strong>Cookies</strong></p> 
              <p style={{ fontSize: 16, marginTop: 5, marginBottom: 5}}>Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers.
                These are sent to your browser from the websites that you visit and are stored on your device's internal
                memory.
              </p> 
              <p style={{ fontSize: 16, marginTop: 5, marginBottom: 5}}>This Service does not use these “cookies” explicitly. However, the app may use third party code and
                libraries that use “cookies” to collect information and improve their services. You have the option to
                either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose
                to refuse our cookies, you may not be able to use some portions of this Service.
              </p>

              <p style={{ fontSize: 20, marginTop: 5, marginBottom: 5}}><strong>Service Providers</strong></p> 
              <p style={{ fontSize: 16, marginTop: 5, marginBottom: 5}}> We may employ third-party companies and individuals due to the following reasons:</p> 
              <ul><li style={{ fontSize: 16, marginTop: 5, marginBottom: 5}}>To facilitate our Service;</li> 
                <li style={{ fontSize: 16, marginTop: 5, marginBottom: 5}}>To provide the Service on our behalf;</li> 
                <li style={{ fontSize: 16, marginTop: 5, marginBottom: 5}}>To perform Service-related services; or</li> 
                <li style={{ fontSize: 16, marginTop: 5, marginBottom: 5}}>To assist us in analyzing how our Service is used.</li>
              </ul> 
              <p style={{ fontSize: 16, marginTop: 5, marginBottom: 5}}> We want to inform users of this Service that these third parties have access to
                your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However,
                they are obligated not to disclose or use the information for any other purpose.
              </p> 

              <p style={{ fontSize: 20, marginTop: 5, marginBottom: 5}}><strong>Security</strong></p> 
              <p style={{ fontSize: 16, marginTop: 5, marginBottom: 5}}> We value your trust in providing us your Personal Information, thus we are striving
                  to use commercially acceptable means of protecting it. But remember that no method of transmission over
                  the internet, or method of electronic storage is 100% secure and reliable, and We cannot guarantee
                  its absolute security.
                </p>
              
              <p style={{ fontSize: 20, marginTop: 5, marginBottom: 5}}><strong>Links to Other Sites</strong></p> 
              <p style={{ fontSize: 16, marginTop: 5, marginBottom: 5}}>This Service may contain links to other sites. If you click on a third-party link, you will be directed
                to that site. Note that these external sites are not operated by us. Therefore, I strongly
                advise you to review the Privacy Policy of these websites. I have no control over
                and assume no responsibility for the content, privacy policies, or practices of any third-party sites
                or services.
              </p> 

              <p style={{ fontSize: 20, marginBottom: 5 }}><strong>Children’s Privacy</strong></p> 
                <p style={{ fontSize: 16, marginBottom: 5 }}>These Services do not address anyone under the age of 13. I do not knowingly collect
                  personally identifiable information from children under 13. In the case we discover that a child
                  under 13 has provided us with personal information, I immediately delete this from
                  our servers. If you are a parent or guardian and you are aware that your child has provided us with personal
                  information, please contact us so that I will be able to do necessary actions.
                  </p>


              <p style={{ fontSize: 20, marginBottom: 5 }}><strong>Changes to This Privacy Policy</strong></p> 
                <p style={{ fontSize: 16, marginBottom: 5 }}> We may update our Privacy Policy from time to time. Thus, you are advised to review
                  this page periodically for any changes. We will notify you of any changes by posting
                  the new Privacy Policy on this page. These changes are effective immediately after they are posted on
                  this page.
                </p>

              <p style={{ fontSize: 20, marginBottom: 5 }}><strong>Contact Us</strong></p>
                <p style={{ fontSize: 16, marginBottom: 5 }}>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact
                    us.</p>
                <p style={{ fontSize: 16, marginBottom: 5 }}>This privacy policy page was created at 
                <a style={{ fontSize: 16, marginBottom: 5 }} href="https://privacypolicytemplate.net" target="_blank">privacypolicytemplate.net</a>
                &nbsp;&nbsp;and modified/generated by &nbsp;&nbsp;
                  <a style={{ fontSize: 16, marginBottom: 5 }} href="https://app-privacy-policy-generator.firebaseapp.com/" target="_blank">App
                  Privacy Policy Generator</a></p>

            </Container>
          </div>
        
        </div>
      </div>
    );
  }
}

export default Policy



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Policy.js